import { render, staticRenderFns } from "./consult-info3.vue?vue&type=template&id=ba76f10e&scoped=true"
import script from "./consult-info3.vue?vue&type=script&lang=js"
export * from "./consult-info3.vue?vue&type=script&lang=js"
import style0 from "./consult-info3.vue?vue&type=style&index=0&id=ba76f10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba76f10e",
  null
  
)

export default component.exports